/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2bundlenetwork {
		get config(){
			return {
				'type':'RelationshipGraph',
				'isRecommendable':false
			};
		}
	}
	return Rave2bundlenetwork;
});